import { ActionReducerMap } from "@ngrx/store";
import { AppState } from "./TransactionDashboard/transactionDashboard.model";
import { transactionDashboardReducer } from "./TransactionDashboard/transactionDashboard.reducer";

type RootState = { 
    transactionDashboardState: AppState
}

export const rootReducer: ActionReducerMap<RootState> = {
    transactionDashboardState: transactionDashboardReducer
};